// Dependencies
import styled from 'styled-components';

const AwardsSliderStyles = styled.section`
  text-align: center;

  .heading {
    margin-bottom: 4.5rem;
  }

  .wrapper {
    padding: 6rem 0 0;
    border-top: 0.063rem solid rgba(127, 17, 224, 0.2);
    filter: grayscale(1);
    opacity: 0.7;
  }

  @media (min-width: 768px) {
    .heading {
      margin-bottom: 6rem;
    }
  }
`;

export default AwardsSliderStyles;
